<!--
  ModalBase.vue
  モーダルの共通コンポーネント
  モーダルを作成する際に本コンポーネントをベースにすること
-->
<template>
    <b-modal
      v-if="isShowModalSync"
      :width="width"
      :active.sync="isShowModalSync"
      :on-cancel="modalClose"
      :can-cancel="canCancel"
    >
    <div class="card -card" :style="styleVariables">
      <!-- タイトル -->
      <header class="card-header -header" v-if="title">
        <p class="card-header-title title">
          {{title}}
        </p>
      </header>
      <!-- モーダルコンテンツ -->
      <slot></slot>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalBase',
  componentName: 'ModalBase',
  props: {
    /**
     * モーダル表示フラグ
     * @type {Boolean}
     */
    isShowModal: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * モーダルタイトル
     * @type {String}
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * キャンセル設定
     * @type {Boolean}
     */
    canCancel: {
      type: Boolean,
      required: false,
    },
    /**
     * モーダル幅
     * @type {String}
     */
    width: {
      type: String,
      default: '650px',
      required: false,
    },
    /**
     * モーダル高さ
     * @type {String}
     */
    height: {
      type: String,
      default: 'auto',
      required: false,
    },
    /**
     * パディング
     * @type {String}
     */
    padding: {
      type: String,
      default: '16px',
      required: false,
    },
    /**
     * クローズ処理
     * @type {Function}
     */
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      /**
       * モーダル表示フラグ
       * @type {Boolean}
       */
      isShowModalSync: this.isShowModal,
    }
  },
  created () {
    if (this.canCancel === true) {
      // ToDo
      // Escキー押下フック
      // モーダル外クリックフック
    }
  },
  watch: {
    /**
     * モーダル表示
     */
    isShowModal() {
      this.isShowModalSync   = this.isShowModal
    },
  },
  computed: {
    /**
     * CSS反映
     */
    styleVariables() {
      return {
        // モーダルの幅
        '--modal-width': this.width,
        // モーダルの高さ
        '--modal-height': this.height,
        // パディング
        '--modal-padding': this.padding,
      }
    },
  },
  methods: {
    modalClose () {
      this.close(false)
    }
  }
}
</script>

<style lang="scss" scoped>
// モーダル
.-card {
  // デフォルト値
  --modal-width: 650px;
  --modal-height: auto;
  --modal-padding: 16px;

  width: var(--modal-width);
  height: var(--modal-height);
  padding: var(--modal-padding);
  z-index: 201;
  border-radius: 8px;
}
// モーダルタイトル
.-header {
  width: 100%;
  p {
    display: block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
// モーダルコンテンツ
.modal-contents {
  // デフォルト値
  --modal-width: 400px;
  --modal-height: auto;
  --modal-padding: 16px;

  width: var(--modal-width);
  height: var(--modal-height);
  padding: var(--modal-padding);
  z-index: 201;
}
// transitionのアニメーション効果
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/hrm-frontend/views/atomic/screen-components/basic-components/base-modal/ModalBase.vue